<template>
  <div>
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck
          v-if="popup=='check'"
          :text="successText"
          @go="popupAction"
          @cancel="poupupEnter"
        >
        <textarea class="input_primary" v-model='reason'></textarea>
        
        </PopupCheck>

        <PopupSuccess v-if="popup=='success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup=='error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="search">
      <i class="el-icon-search"></i>
      <input type="text" placeholder="搜尋" v-model="searchKey" />
    </div>
    <div class="table_outter_block">
      <Table
        ref="table"
        :column="thead"
        :fixedColumn="fixedColumn"
        :data="data"
        :type="type"
        @check="vendorCheck"
        @cancel="vendorCancel"
      ></Table>
    </div>
  </div>
</template>
<style lang="scss">
.search {
  // background: #fff;
  width: fit-content;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  input {
    // border: none;
    background: transparent;
    border: none;
  }
  &:focus-within {
    border: 1px solid var(--mainColor);
  }
}
</style>

<script>
import Table from "@/components/Table.vue";
export default {
  name: "contractorList",
  data() {
    return {
      data: [],
      type: "admin-review",
      thead: [
        {
          name: "操作",
          width: "45px",
          val: "action"
        },
        {
          name: "審核",
          width: "45px",
          val: "is_pass"
        },
        {
          name: "承攬商名稱",
          width: "250px",
          val: "vendor_chinese"
        },
        {
          name: "統一編號",
          val: "tax_id",
          width: "150px"
        },
        // {
        //   name: "地址",
        //   width: "200px",
        //   val: "company_address"
        // },
        {
          name: "聯絡人",
          width: "150px",
          val: "contact_person"
        },
        {
          name: "電話",
          width: "120px",
          val: "phone"
        }
        // {
        //   name: "信箱",
        //   width: "250px",
        //   val: "email"
        // }
      ],
      fixedColumn: ["action", "vendor_chinese"],
      searchKey: null,
      popupStatus: false,
      successText: null,
      popup: null,
      action_item: null,
      reason:null
    };
  },
  components: {
    Table
  },
  methods: {
    getData(name) {
      this.$http.api.admin.vendorList(name).then(res => {
        this.data = [];
        res.data.forEach(el => {
          if (el.is_pass !== 2) {
            this.data.push(el);
          }
        });
      });
    },
    vendorCheck(item) {
      this.$http.api.admin
        .vendorCheck(item.vendor_id)
        .then(res => {
          this.popupStatus = true;
          this.successText = "審核成功";
          this.popup = "success";
          this.getData();
        })
        .catch(error => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "審核失敗";
        });
    },
    vendorCancel(item) {
      this.action_item = item;
      this.popupStatus = true;
      this.popup = "check";
      this.successText = `
          請填寫審核不通過之原因:<br><br>
          `;
    },
    poupupEnter() {
      this.popupStatus = false;
      this.$refs.table.tableMenu.index = null;
    },
    popupAction() {
      this.$http.api.admin
        .vendorCancel(this.action_item.vendor_id,{
          reason:this.reason
        })
        .then(res => {
          this.reason=null;
          this.popupStatus = true;
          this.successText = "操作成功";
          this.popup = "success";
          this.getData();
        })
        .catch(error => {
          this.reason=null;
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "操作失敗";
        });
    }
  },
  watch: {
    searchKey(newVal, oldVal) {
      this.getData(newVal);
    }
  },
  mounted() {
    this.getData();
  }
};
</script>